'use client';

import { Avatar } from "@chakra-ui/react";
import { useUser } from "~/hooks/useUser";
import { getFullName } from "@habity/services";

export function UserAvatar() {
  const { user } = useUser();

  return (
    <Avatar
      boxSize="10"
      name={getFullName(user)}
      backgroundColor="burntOrange"
      color="white"
      fontWeight="medium"
      size="14px"
      src={user?.avatar_url || undefined}
    />
  );
}
